import Marquee from "react-fast-marquee";

export function BrandMarquee() {
  return (
    <section className="border-y border-black/5 bg-cream py-8" data-testid="marquee" aria-hidden>
      <Marquee speed={38} gradient={false} autoFill>
        {["Made to Shine.", "Made to Last.", "Anti-Tarnish.", "Everyday Luxury.", "Made to Shine.", "Made to Last."].map(
          (t, i) => (
            <span
              key={i}
              className="mx-8 font-serif text-4xl font-light italic text-ink/25 md:text-6xl"
            >
              {t} <span className="not-italic text-gold/50">✦</span>
            </span>
          )
        )}
      </Marquee>
    </section>
  );
}
